import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function createProduct(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.createProduct
  const storeData = await self.servicesVars.getStoreData()

  const body = {
    title: data.name,
    price: data.price,
    currency: storeData.currency,
    storeId: storeData.id,
    storeName: storeData.storeName,
    description: data.description,
    category: data.category,
    categoryId: data.categoryId,
    subcategory: data.subcategory,
    subcategoryId: data.subcategoryId,
    principalImageUrl: data.image,
    brand: data.brand || '',
    color: data.color || [],
    size: data.size || [],
    material: data.material || '',
    condition: data.condition || '',
    weight: data.weight || [],
    quantity: data.quantity,
    additionalImageUrl: data.images,
    downloadLink: data.downloadLink || '',
    isDigitalProduct: data.isDigitalProduct || false,
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { createProduct }
